export const convertStringToAlphanumericWithDash = (value: string) => {
  value = value.startsWith('-') ? value.slice(1) : value // Remove leading dashes.

  return value
    .toLowerCase() // Convert to lowercase.
    .replace(/[^a-zA-Z0-9-]/g, '') // Replace all characters that are not letters, digits, or dashes with an empty string.
    .replace(/-+/g, '-') // Replacing sequences of dashes with a single dash.
}
